
const Camping = () => {
    return (
        <h1>Camping</h1>
    )
}

export default Camping;
